import { render, staticRenderFns } from "./PackagePage.vue?vue&type=template&id=dcc60fc4&scoped=true&"
import script from "./PackagePage.vue?vue&type=script&lang=js&"
export * from "./PackagePage.vue?vue&type=script&lang=js&"
import style0 from "./PackagePage.vue?vue&type=style&index=0&id=dcc60fc4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcc60fc4",
  null
  
)

export default component.exports